import { hydrateWidgets } from 'DVWebNodeUtils';
import { RetailNav } from 'DVWebNodeNav/RetailNav';
hydrateWidgets(RetailNav);
